export default __webpack_public_path__ + "static/media/arc-accent.8ff5743d.svg";